import { Card, CardAction, CardContent, CardHeader, CardTitle } from '@nesso/ui/primitives/card';
import { Skeleton } from '@nesso/ui/primitives/skeleton';

export function PlanBillingPlanCardSkeleton() {
    return (
        <Card className="mb-8">
            <CardHeader>
                <CardTitle className="text-base font-bold">Current plan</CardTitle>
                <CardAction>
                    <Skeleton className="h-7.5 w-28" />
                </CardAction>
                <div className="flex items-end gap-2">
                    <Skeleton className="h-8 w-12" />
                    <Skeleton className="h-4 w-24" />
                </div>
            </CardHeader>
            <CardContent>
                <Skeleton className="h-2 w-full" />
            </CardContent>
        </Card>
    );
}
